export type SectionDisplayName = (typeof APP_SECTION)[keyof typeof APP_SECTION]['DISPLAY_NAME'];

export const APP_SECTION = {
  COMFORT: {
    KEY: 'COMFORT',
    DISPLAY_NAME: 'Comfort',
  },
  ENERGY: {
    KEY: 'ENERGY',
    DISPLAY_NAME: 'Energy',
  },
  EV: {
    KEY: 'EV',
    DISPLAY_NAME: 'EV',
  },
  BATTERY: {
    KEY: 'BATTERY',
    DISPLAY_NAME: 'Battery',
  },
  TRENDS: {
    KEY: 'TRENDS',
    DISPLAY_NAME: 'Trends',
  },
  SOLAR: {
    KEY: 'SOLAR',
    DISPLAY_NAME: 'Solar',
  },
  SCHEDULER: {
    KEY: 'SCHEDULER',
    DISPLAY_NAME: 'Scheduler',
  },
  SCHEDULES: {
    KEY: 'SCHEDULES',
    DISPLAY_NAME: 'Schedules',
  },
  EVENTS: {
    KEY: 'EVENTS',
    DISPLAY_NAME: 'Events',
  },
  RESOURCES: {
    KEY: 'RESOURCES',
    DISPLAY_NAME: 'Resources',
  },
  USER_SETTINGS: {
    KEY: 'USER_SETTINGS',
    DISPLAY_NAME: 'User Settings',
  },
};
